import React from "react";
export default function CertCompliance() {
  return (
    <div className="section borderLight">
      <h2> CertCompliance</h2>
      <p>Coming soon</p>
    </div>
  );
}
